import Icon from "./IconBase.js";
const CheckboxDisabled = (props) => {
  return (
    <Icon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="16" height="16" rx="3" fill="#AFAFAF" />
        <path
          d="M12 5L6.5 10.5L4 8"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default CheckboxDisabled;
